import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api'
import { DEFAULT_INSURANCE_ID } from '@backmarket/nuxt-layer-checkout/constants'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'

export function getSelectedInsuranceOffers(
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
): InsuranceOfferWithSelectedState[] {
  return items
    .map((item) => item.insuranceOffers.find((offer) => offer.selected))
    .filter(
      (offer): offer is InsuranceOfferWithSelectedState =>
        !!offer && offer.id.toString() !== DEFAULT_INSURANCE_ID,
    )
}
